<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="ruleForm" inline>
        <el-form-item label="工厂信息" prop="companyName">
          <el-input
            v-model="listForm.companyName"
            placeholder="请输入工厂名称或编号"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人信息" prop="contactPerson">
          <el-input
            v-model="listForm.contactPerson"
            placeholder="请输入联系人姓名或电话"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-row :gutter="10" class="button-box" style="margin-top: 10px !important">
      <el-col :span="1.5" class="add-btn">
        <el-button
          icon="el-icon-download"
          :disabled="isSync"
          type="primary"
          @click="synFactoruBtn"
          >立即同步</el-button
        >
      </el-col>
      <div class="sync-box" v-show="syncShow">
        <div>{{ syncStatus }}</div>
        <div style="margin-top: 10px">
          <span>已同步{{ syncNumber }}条</span
          ><span style="margin-left: 20px">已耗时{{ syncDate }}</span>
        </div>
      </div>
      <div class="sync-box sync-box1" v-show="haveSyncShow">
        <div>
          计划自动同步时间：{{ syncStartDatePlan
          }}<span
            style="margin-left: 20px"
            v-if="syncMode == 1 || syncMode == '1'"
            >同步方式：自动</span
          ><span
            style="margin-left: 20px"
            v-if="syncMode == 2 || syncMode == '2'"
            >同步方式：手动</span
          >
        </div>
        <div style="margin-top: 10px">
          <span>最近同步时间：{{ updateDate }}</span>
        </div>
      </div>
    </el-row> -->
    <el-table :data="list" style="width: 100%" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="工厂名称"
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="companyCode"
        label="工厂编号"
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="contactPerson"
        label="联系人"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="contactPhone"
        label="联系电话"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        label="超管帐号"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="updateUser"
        label="最后操作人"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="最后操作时间"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column floa="right" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="editBtn(scope.row)"
          >
            编辑</el-button
          >
          <el-button
            style="margin-top: 10px"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="resetPwdBtn(scope.row)"
          >
            重置密码</el-button
          >
          <el-button
            style="margin-top:10px"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="updateBtn(scope.row)"
          >
            修改角色</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :current-page="listForm.pageNum"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="800px"
      @close="dialogEditClose"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editRule"
        label-width="150px"
      >
        <div class="audit-line">基本信息</div>
        <el-row>
          <el-col :span="16">
            <el-form-item label="工厂编号" prop="companyCode">
              <el-input disabled v-model="editForm.companyCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="工厂名称" prop="companyName">
              <el-input disabled v-model="editForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="editForm.contactPerson"
                placeholder="请输入联系人"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="联系人手机号" prop="contactPhone">
              <el-input
                v-model="editForm.contactPhone"
                placeholder="请输入手机号"
                @blur="setAccount"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="address">
              <div class="address-city">
                <el-form-item label="企业地址：" prop="companyAddress">
                  <el-cascader
                    ref="province"
                    :options="options"
                    v-model="companyAddress"
                    expand-trigger="click"
                    filterable
                  >
                  </el-cascader>
                </el-form-item>
              </div>
              <div class="address-detail">
                <el-form-item prop="address">
                  <el-input
                    v-model="editForm.address"
                    placeholder="详细地址"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="audit-line">
          企业配置<span style="color: #f56c6c; margin-left: 10px">(必填)</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录账号（超管）" prop="userName">
              <el-input
                v-model="editForm.userName"
                placeholder="请输入手机号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="初始登录密码">
              <el-input disabled placeholder="联系人手机号后六位" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveDataEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改角色"
      :visible.sync="dialogUpdate"
      :close-on-click-modal="false"
      width="800px"
      @close="handleClose3" 
      
    >
      <el-form
        :model="updateCompanyRoles"
        ref="companyInfo"
        label-width="100px"
        class="company-form"
      >
        <el-form-item label="企业名称：">
          <span>{{ updateCompanyRoles.companyName }}</span>
        </el-form-item>
        <el-form-item label="企业角色：" prop="roldId">
          <el-select v-model="updateCompanyRoles.roleId">
            <el-option
              v-for="item in rolesList"
              :label="item.roleName"
              :key="item.roleId"
              :value="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogUpdate = false">取 消</el-button>
        <el-button type="primary" @click="saveUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  comanyPageList,
  syncFactory,
  queryChildrenRolesByCompanyType,
  getAllTracecodeRuleList,
  updateRoleDistribution,
  companyInfoDetail,
  getScanAllList,
  uploadImage,
  companyUpdateStatus,
  saveEditCompany,
  resetPwd,
  getSyncTaskById,
  syncCurrentTask,
} from "@/common/api.js";
import options from "@/common/province.json";
export default {
  components: {},
  props: {},
  data() {
    return {
      total: 0,
      list: [],
      loading: false,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        companyType: 1,
        companyName: "",
        contactPerson: "",
      },
      haveSyncShow: false, //无同步任务
      syncStartDatePlan: "", //计划同步时间
      updateDate: "", //同步时间
      syncMode: "",
      isSync: false,
      syncShow: false,
      syncDate: "0秒",
      syncStatus: "正在同步",
      syncNumber: 0,
      task: null,
      // 编辑
      dialogEdit: false,
      title: "编辑",
      options: options,
      companyAddress: [],
      editForm: {
        companyId: "",
        companyName: "", //名称
        contactPerson: "",
        contactPhone: "",
        provCode: "",
        cityCode: "",
        areaCode: "",
        address: "",
        userName: "",
      },
      // 修改角色
      dialogUpdate: false,
      rolesList: [],
      updateCompanyRoles: {
        companyName: "",
        roleId: "",
        companyId: "",
      },
      editRule: {
        contactPerson: [
          { required: true, validator: this.testPerson, trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: this.testPhone, trigger: "change" },
        ],
        userName: [
          { required: true, validator: this.testUserName, trigger: "change" },
        ],
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 企业列表
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      comanyPageList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 查询任务
    getLastTask() {
      syncCurrentTask({ syncType: 1 }).then((res) => {
        if (res.errorCode == 200) {
          if (res.data.syncStatus == "1") {
            this.haveSyncShow = false;
            this.syncShow = this.isSync = true;
            this.task = setInterval(() => {
              this.syncTask(res.data.id);
            }, 3000);
          } else {
            this.haveSyncShow = true;
            this.syncStartDatePlan = res.data.syncStartDatePlan;
            this.updateDate = res.data.updateDate;
            this.syncMode = res.data.syncMode;
          }
          console.log(this.syncStartDatePlan);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 同步工厂
    synFactoruBtn(evt) {
      this.$confirm("该过程可能用时较长，请耐心等待！", "确定要同步工厂吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.syncShow = this.isSync = true;
          this.haveSyncShow = false;
          syncFactory().then((res) => {
            if (res.errorCode == 200) {
              this.task = setInterval(() => {
                this.syncTask(res.taskId);
              }, 3000);
            } else {
              this.isSync = false;
              this.$message.error(res.msg);
            }
          });
        })
        .catch((e) => {
          this.isSync = false;
        });
      let target = evt.target;
      if (target.nodeName == "SPAN") {
        target = evt.target.parentNode;
      }
      target.blur();
    },
    // 同步任务
    syncTask(id) {
      let params = {
        id: id,
      };
      getSyncTaskById(params).then((res) => {
        if (res.errorCode == 200) {
          if (res.data.syncStatus == "1") {
            this.syncStatus = "正在同步";
          } else if (res.data.syncStatus == "2") {
            this.syncStatus = "同步完成";
          } else if (res.data.syncStatus == "3") {
            this.syncStatus = "同步失败";
          }
          this.syncNumber =
            Number(res.data.addNumer) + Number(res.data.updateNumber);
          this.syncDate = this.formatSyncDate(res.data.syncDate);
          if (res.data.syncStatus == "2" || res.data.syncStatus == "3") {
            this.isSync = false;
            clearInterval(this.task);
          }
        } else {
          this.$message.error(res.msg);
          this.isSync = false;
          clearInterval(this.task);
        }
      });
    },
    formatSyncDate(value) {
      var secondTime = parseInt(value);
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime <= 60) {
        return secondTime + "秒";
      }
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
          return hourTime + "小时" + minuteTime + "分钟" + secondTime + "秒";
        } else {
          return minuteTime + "分钟" + secondTime + "秒";
        }
      }
    },
    // 修改角色
    updateBtn(row) {
      this.dialogUpdate = true;
      this.updateCompanyRoles.companyName = row.companyName;
      var data = {
        companyType: row.companyType,
      };
      queryChildrenRolesByCompanyType(data).then((res) => {
        if (res.errorCode == 200) {
          this.rolesList = res.data;
          var companyId = row.companyId;
          var params = {
            companyId,
          };
          this.$nextTick(() => {
            companyInfoDetail(params).then((res1) => {
              if (res1.errorCode == 200) {
                this.updateCompanyRoles.roleId = res1.companyUsers.roleId;
                this.updateCompanyRoles.companyId= row.companyId;
              } else {
                this.$message.error(res1.msg);
              }
            });
          });
        }
      });
    },
    saveUpdate() {
      updateRoleDistribution(this.updateCompanyRoles).then((res) => {
        console.log(res);
        if (res.errorCode == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.dialogUpdate = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClose3() {
      this.updateCompanyRoles = {
        companyName: "",
        roleId: "",
        companyId: "",
      };
    },
    resetPwdBtn(row) {
      console.log(row);
      let name = row.companyName;
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", { style: "margin-bottom: 10px" }, name),
          h(
            "h3",
            { style: "margin-bottom: 10px" },
            "请确认是否重置该工厂的超管登录密码?"
          ),
          h("h3", { style: "margin-bottom: 10px" }, "重置后密码：000000"),
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            let params = {
              companyId: row.companyId,
              password: "000000",
            };
            resetPwd(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            done();
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    setAccount() {
      this.editForm.userName = this.editForm.contactPhone;
    },
    // 编辑
    editBtn(row) {
      this.dialogEdit = true;
      this.editForm = {
        companyId: row.companyId,
        companyCode: row.companyCode,
        companyName: row.companyName,
        contactPerson: row.contactPerson,
        contactPhone: row.contactPhone,
        address: row.address,
        provCode: row.provCode,
        cityCode: row.cityCode,
        areaCode: row.areaCode,
        userName: row.userName,
        companyUsers: {},
      };
      this.companyAddress = [row.provCode, row.cityCode, row.areaCode];
    },
    // 编辑保存、
    saveDataEdit() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.editForm.provCode = this.companyAddress[0];
          this.editForm.cityCode = this.companyAddress[1];
          this.editForm.areaCode = this.companyAddress[2];
          var params = this.editForm;
          console.log(this.editForm);
          saveEditCompany(params).then((res) => {
            if (res.errorCode == 200) {
              this.dialogEdit = false;
              this.getPageList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    //变更状态
    statusChange(row) {
      var mess = "";
      let text = "";
      if (row.status == 1) {
        text = "启用";
      } else if (row.status == 0) {
        text = "禁用";
        mess = "设置为禁用后，该企业无法登录平台，请谨慎操作。";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '是否"' + text + '"该企业？', "警告"),
          h("p", { style: "color:#f06565" }, mess),
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              companyId: row.companyId,
              status: row.status,
              companyCode: "",
            };
            companyUpdateStatus(params).then((res) => {
              if (res.errorCode == "200") {
                // this.btnDisabled = row.status == 0 ? true : false;
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log();
        })
        .catch(() => {
          console.log();
        });
    },
    // 角色列表
    getRoles(type) {
      var params = {
        companyType: type,
      };
      queryChildrenRolesByCompanyType(params).then((res) => {
        if (res.errorCode == 200) {
          this.rolesList = res.data;
        }
      });
    },
    // 获取所有码规则
    getAllTracecodeRuleList() {
      var data = {};
      getAllTracecodeRuleList(data).then((res) => {
        this.tracecodeRuleList = res.data;
      });
    },
    // 有效期
    getAfterYear(startDate, nextYear) {
      var expriedYear = parseInt(startDate.substring(0, 4)) + nextYear;
      var expriedMonth = startDate.substring(4, 6);
      var expriedDay = startDate.substring(6);
      if (expriedMonth == "02" || expriedMonth == 2) {
        var monthEndDate = new Date(expriedYear, expriedMonth, 0).getDate();
        if (parseInt(expriedDay) > monthEndDate) {
          expriedDay = monthEndDate;
        }
      }
      return expriedYear + expriedMonth + expriedDay;
    },
    getDateList() {
      this.dateList = [];
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      var nowDate = year + "-" + month + "-" + day;
      for (var k = 1; k < 6; k++) {
        var nestyear = this.getAfterYear(nowDate, k);
        this.dateList.push({
          date: nestyear,
          val: "（有效期" + k + "年）",
          years: k,
        });
      }
      console.log(this.dateList);
    },
    //模板列表
    getTemplateList() {
      getScanAllList().then((res) => {
        if (res.errorCode == 200) {
          this.templateList = res.data;
        }
      });
    },
    // 上传产品图片
    uploadFile(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG =
        file.companyType === "image/jpg" || "image/png" || "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传成功
    handleUpSuccess(id, res, file) {
      console.log(file);
      this.companyCertList[id].certificateUrl = res.url;
    },
    // 上传失败
    handleUpError(err, file, fileList) {
      this.$message.error(err);
    },
    testPerson(rule, value, callback) {
      if (value) {
        if (value.length > 10) {
          callback(new Error("最多输入10个字符"));
        }
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入联系人"));
      }
    },
    testPhone(rule, value, callback) {
      if (value) {
        var checkRule = /^1[3456789]\d{9}$/;
        var mobile = checkRule.test(value);
        if (!mobile) {
          callback(new Error("手机号码格式不正确，请重新输入"));
        }
        callback();
      } else {
        callback(new Error("请输入手机号"));
      }
    },
    testAddress(rule, value, callback) {
      if (this.companyAddress.length == 0) {
        callback(new Error("请选择企业地址"));
      }
      callback();
    },
    testUserName(rule, value, callback) {
      if (value) {
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入超管帐号"));
      }
    },
    dialogEditClose() {
      this.$nextTick(() => {
        this.editForm = {
          companyId: "",
          companyName: "", //名称
          contactPerson: "",
          contactPhone: "",
          provCode: "",
          cityCode: "",
          areaCode: "",
          address: "",
          userName: "",
          companyUsers: {},
        };
        this.companyAddress = [];
        this.$refs["editForm"].resetFields();
      });
    },
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.listForm = {
          pageNum: 1,
          pageSize: 10,
          companyType: 1,
          companyName: "",
          contactPerson: "",
        };
        this.getPageList();
      });
    },

    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.$nextTick(() => {
        this.listForm.pageSize = psize;
      });
      this.getPageList();
    },
  },
  created() {},
  mounted() {
    this.getPageList();
    this.getDateList();
    this.getAllTracecodeRuleList();
    this.getTemplateList();
    this.getLastTask();
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.task);
  },
  filters: {
    getprov(code) {
      options.forEach((item, index) => {
        if (code == item.value) {
          code = item.label;
        } else if (item.children.length > 0) {
          item.children.forEach((c) => {
            if (code == c.value) {
              code = c.label;
            } else {
              if (c.children.length > 0) {
                c.children.forEach((cc) => {
                  if (code == cc.value) {
                    code = cc.label;
                  }
                });
              }
            }
          });
        }
      });
      return code;
    },
    companyType(value) {
      if (value == 2) {
        return "生产企业";
      } else if (value == 4) {
        return "塑业企业企业";
      }
      if (value == 8) {
        return "终端门店";
      } else {
        return "";
      }
    },
    authFlag(value) {
      if (value == 0) {
        return "未审核";
      } else if (value == 1) {
        return "审核中";
      } else if (value == 2) {
        return "审核通过";
      } else if (value == 3) {
        return "审核不通过";
      } else {
        return "";
      }
    },
    status(value) {
      if (value == 1) {
        return "营业";
      } else if (value == 2) {
        return "吊销";
      } else if (value == 3) {
        return "停业";
      } else if (value == 4) {
        return "注销";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-row {
    margin: 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
    .standard-code {
      font-size: 14px;
      color: #8f8f8f;
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
    }
    .el-select {
      width: 100%;
    }
    .expiry-date /deep/.el-form-item__content {
      margin-left: 10px !important;
    }
  }
  .sync-box {
    float: right;
    margin-right: 20px;
    color: #f56c6c;
    font-size: 14px;
    text-align: right;
  }
  .sync-box1 {
    color: #333333;
  }
  .button-box {
    padding: 15px !important ;
  }
  .audit-line {
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
    margin-bottom: 15px;
  }
  .line-border {
    border-top: dashed 1px #d1d1d1;
    padding-top: 20px;
  }
  // /deep/.el-input__inner,
  // /deep/.el-form-item__content {
  //   height: 34px;
  //   line-height: 34px;
  // }
  // /deep/.el-input__icon,
  // /deep/.el-form-item__label {
  //   line-height: 34px;
  // }
  .detail-main {
    /deep/.el-form-item {
      margin-bottom: 10px !important;
    }
  }
  .el-tabs {
    background: #fff;
  }
  /deep/.el-tabs__header {
    margin-top: 10px;
  }
  .content {
    background: #fff;
    padding: 20px;
    div {
      margin-bottom: 30px;
      .span1 {
        display: inline-block;
        width: 160px;
      }
    }
    input {
      width: 18%;
      border: 1px solid #eee;
      height: 40px;
    }
  }
  .btnbox {
    padding-left: 20px;
    margin: 20px 0;
  }
  .check-submit {
    padding: 20px 0 0 100px;
  }
  .avtive {
    background-color: #62a8ea;
    color: #fff;
  }
  .company-form {
    padding: 20px;
  }
  a.toview {
    color: #62a8ea;
  }
  .address {
    display: flex;
    justify-content: space-between;
    .address-city {
      width: 56%;
    }
    .address-detail {
      width: 40%;
      margin-right: 2%;
      /deep/.el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  /deep/.el-tabs__nav-wrap {
    padding-left: 20px;
  }
  /deep/.el-button {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
  }
  .el-cascader {
    width: 100%;
  }
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .avatar {
      width: 120px;
      height: 120px;
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/businessManage/factoryManage.vue